import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import { Competition } from "../api/Dtos";
import { useAxiosInterceptors } from "../api/AxiosConfig";

export interface GlobalState {
  competition?: Competition;
  setCompetition: React.Dispatch<React.SetStateAction<Competition | undefined>>;
  authorizedAs: string | undefined;
  setAuthorizedAs: (isAuthorized: string | undefined) => void;
}

const GlobalContext = createContext<GlobalState | undefined>(undefined);

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};

/////////////////////////////////////////////////
// The global provider component

interface GlobalProviderProps {
  children: ReactNode;
}

export const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
  const [competition, setCompetition] = useState<Competition | undefined>(
    () => {
      const stored = sessionStorage.getItem("competition");
      return stored ? JSON.parse(stored) : undefined;
    }
  );
  const [authorizedAs, setAuthorizedAs] = useState<string | undefined>(() => {
    return sessionStorage.getItem("authorizedAs") || undefined;
  });

  useEffect(() => {
    if (competition) {
      sessionStorage.setItem("competition", JSON.stringify(competition));
    } else {
      sessionStorage.removeItem("competition");
    }
  }, [competition]);

  useEffect(() => {
    if (authorizedAs) {
      sessionStorage.setItem("authorizedAs", authorizedAs);
    } else {
      sessionStorage.removeItem("authorizedAs");
    }
  }, [authorizedAs]);

  useAxiosInterceptors(); //setAuthorizedAs);

  return (
    <GlobalContext.Provider
      value={{
        competition,
        setCompetition,
        authorizedAs,
        setAuthorizedAs,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
